module.exports = __webpack_public_path__ + "assets/img/car21.332b8f40.jpg";